export default __webpack_public_path__ + "static/slide_7-246e431c28b5f14a3d5fdd73511cbc87.png";